const CHECK_INTERVAL_MS = 5 * 60 * 1000;
const ENTRY_BUNDLE_RE = /(?:^|\/)static\/js\/(main\.[a-f0-9]+\.js)(?=[?#"'\s<]|$)/i;

let lastCheckAt = -Infinity;
let lastResult = false;
let pendingCheck = null;

const bundleFromUrl = (url) => url?.match(ENTRY_BUNDLE_RE)?.[1] ?? null;

export function currentBundle() {
  if (typeof document === "undefined") return null;
  for (const script of document.querySelectorAll("script[src]")) {
    const bundle = bundleFromUrl(script.getAttribute("src"));
    if (bundle) return bundle;
  }
  return null;
}

export async function checkForNewRelease({ fetchImpl = fetch, now = Date.now } = {}) {
  const current = currentBundle();
  if (!current) return false;

  const checkedAt = now();
  if (checkedAt - lastCheckAt < CHECK_INTERVAL_MS) {
    return pendingCheck ?? lastResult;
  }

  lastCheckAt = checkedAt;
  pendingCheck = (async () => {
    try {
      const response = await fetchImpl("/index.html", { cache: "no-store" });
      if (response.ok === false) return false;
      const html = await response.text();
      const latest = bundleFromUrl(html);
      return latest !== null && latest !== current;
    } catch {
      return false;
    }
  })();

  lastResult = await pendingCheck;
  pendingCheck = null;
  return lastResult;
}
